//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { windowMatchMediaMixin } from '~/mixins/matchMedia';
import EmailBrochureForm from './EmailBrochureForm.vue';

export default {
  name: 'TopFooterForm',
  mixins: [windowMatchMediaMixin],
  components: {
    EmailBrochureForm,
  },
  data() {
    return {
      isNotSubmitted: true,
      resetTimeout: null,
    };
  },
  computed: {
    view_name() {
      return `${this.$route.name}_${this.$options.name}`;
    },
    fcLogoWidth() {
      return this.mixinMatchMedia.isTabletUp ? '119px' : '84px';
    },
    fcLogoHeight() {
      return this.mixinMatchMedia.isTabletUp ? '89px' : '67px';
    },
  },
  beforeDestroy() {
    if (this.resetTimeout) {
      clearTimeout(this.resetTimeout);
    }
  },
  methods: {
    getLinkName(name) {
      return `${this.view_name}_${name}`;
    },
    handleSubmission() {
      this.isNotSubmitted = !this.isNotSubmitted;

      // Reset back to form after 5 seconds
      this.resetTimeout = setTimeout(() => {
        this.isNotSubmitted = true;
      }, 3000);
    },
  },
};
